import styled from '@emotion/styled';
import { Label, Segment } from 'semantic-ui-react';
import { LegendEntry } from 'components';
import { useSelector } from 'react-redux';
import { speakingSessionStore } from 'store';
import { useLocation } from 'react-router';
import { EditRoomRouteState } from './structures/types';

export const SpeakingSlotsFooter = () => {
  const location = useLocation();
  const routeState = (location.state ?? {}) as EditRoomRouteState;
  const editedRoomId = routeState.roomId;
  const baseSlotCounts = useSelector(speakingSessionStore.selectors.slotCountsState);
  const slotCountsWithEditedRoom = useSelector(
    speakingSessionStore.selectors.slotCountsWithEditedRoomState
  );

  const slotCounts = editedRoomId === undefined ? baseSlotCounts : slotCountsWithEditedRoom;

  return (
    <S.Footer attached>
      <S.Legend>
        <LegendEntry color="#415561" text="IPC" data-testid="legend-ipc" />
        <LegendEntry color="#19b6ad" text="IPA" data-testid="legend-ipa" />
        <LegendEntry color="#de3494" text="RSS" data-testid="legend-rss" />
        <LegendEntry color="#9f07d2" text="SWA" data-testid="legend-swa" />
      </S.Legend>
      <S.Legend>
        <S.Counter>
          <Label circular color="green" data-testid="available-count">
            {slotCounts.available}
          </Label>
          Available
        </S.Counter>
        <S.Counter>
          <Label circular color="yellow" data-testid="awaiting-approval-count">
            {slotCounts.awaitingApproval}
          </Label>
          Awaiting approval
        </S.Counter>
        <S.Counter>
          <S.RejectedLabel circular data-testid="rejected-count">
            {slotCounts.rejected}
          </S.RejectedLabel>
          Rejected
        </S.Counter>
        <S.Counter>
          <Label circular color="red" data-testid="booked-count">
            {slotCounts.booked}
          </Label>
          Booked
        </S.Counter>
      </S.Legend>
    </S.Footer>
  );
};

const S = {
  Footer: styled(Segment)`
    &.ui.segment {
      display: flex;
      position: fixed;
      bottom: 0;
      justify-content: space-between;
      top: unset;
      width: calc(100% - 260px);
      margin: unset;
      z-index: 9999;
      height: 50px;
      left: 260px;
    }
  `,
  Legend: styled.div`
    display: flex;
    gap: 1rem;
  `,
  Counter: styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
  `,
  RejectedLabel: styled(Label)`
    background-color: #f3f4f5 !important;
    color: #909090 !important;
  `,
};
